export const closeEditWorkerDialogReducer = (state) => {
	state.editWorkerDialog.isOpen = false;
	state.editWorkerDialog.workerId = "";
	state.editWorkerDialog.currentStep = 0;
	state.editWorker.status = "idle";
	state.editWorker.errorMessage = "";
};
